import { find, findAll } from "../utils/dom";


const PageConcertosSingle = () =>{
	const page = find(`[js-page='single-artista']`);


	if(!page) return;

	const COLOR_TAG = /\[color=(?:"|')?([^\]]+?)(?:"|')?\]([\s\S]*?)\[\/color\]/gi;
	const $ = {
		repetorio: findAll('[js-repetorio]'),
	}
	

	// Aceita: #hex, rgb/rgba(), hsl/hsla(), ou nome CSS simples (ex: red, blue)
	/**
	 * Função: isSafeColor
	 * Descrição: Essa função verifica se a cor (v) é uma representação válida.
	 *  */
function isSafeColor(v) {
  v = v.trim();
  return (
    /^#([0-9a-f]{3}|[0-9a-f]{4}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(v) ||
    /^(rgb|rgba|hsl|hsla)\(\s*[^)]+\)$/.test(v) ||
    /^[a-z]{1,30}$/i.test(v)
  );
}

function bbcodeColorToHtml(input) {
  let out = String(input);
  let prev;
  do {
    prev = out;
    out = out.replace(COLOR_TAG, (_, color, content) => {
      const c = color.trim();
      const style = isSafeColor(c) ? ` style="color:${c}"` : "";
      return `<span${style}>${content}</span>`;
    });
  } while (out !== prev); // repete até não restarem tags
  return out;
}



	$.repetorio.forEach((item)=>{
		const text = item.innerHTML;
		const novoTexto = bbcodeColorToHtml(text);

		item.innerHTML = `${novoTexto}`;
	})
}

export default PageConcertosSingle;